<template>
  <div :class="name">
    <div :class="`${name}-header`">
      <span class="title">{{ $t('module_creative_post_tutorial') }}</span>
    </div>

    <div :class="`${name}-stepDesc`">
      {{ describeText }}
    </div>

    <vi-carousel
      ref="carouselTutorial"
      :class="`${name}-tutorialImg`"
      :autoplay="false"
      indicator-position="none"
      height="387px"
      @change="onStepChange"
    >
      <vi-carousel-item v-for="(item, index) in imgList" :key="item.key">
        <vi-image
          :class="`${name}-image`"
          :src="item.url"
          fit="fill"
          data-tea-expose="tt_post_auth_guide"
          :data-tea-message="++index"
        >
        </vi-image>
      </vi-carousel-item>
    </vi-carousel>

    <div :class="`${name}-operation`">
      <vi-button type="text" :disabled="currentStep <= MIN_STEP" @click="onChangeActiveItem(false)">
        <i class="vi-icon2-arrowleft"></i>
      </vi-button>
      <span :class="`stepNum`">{{ currentStep }} / {{ totalStep }}</span>
      <vi-button type="text" :disabled="currentStep >= totalStep" @click="onChangeActiveItem(true)">
        <i class="vi-icon2-arrowright"></i>
      </vi-button>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, ref } from '@vue/composition-api';
import { i18n } from '@/i18n';
import postAuthorizationStep1 from '@tt4b/ttam-assets/src/images/creative/tiktok-post/post_authorization_step1.gif';
import postAuthorizationStep2 from '@tt4b/ttam-assets/src/images/creative/tiktok-post/post_authorization_step2.gif';
import postAuthorizationStep3 from '@tt4b/ttam-assets/src/images/creative/tiktok-post/post_authorization_step3.gif';
import postAuthorizationStep4 from '@tt4b/ttam-assets/src/images/creative/tiktok-post/post_authorization_step4.gif';
const MIN_STEP = 1;
const MAX_STEP = 4;
const name = 'ttam-identity-tiktok-post-authorization-preview';
export default defineComponent({
  name: 'TutorialPreview',
  props: {},
  setup() {
    const carouselTutorial = ref();
    const currentStep = ref(MIN_STEP);
    const totalStep = ref(MAX_STEP);

    const imgList = computed(() => [
      {
        key: 0,
        describe: i18n.t('module_creative_post_tutorial_step_one'),
        url: postAuthorizationStep1,
      },
      {
        key: 1,
        describe: i18n.t('module_creative_post_tutorial_step_two'),
        url: postAuthorizationStep2,
      },
      {
        key: 2,
        describe: i18n.t('module_creative_post_tutorial_step_three'),
        url: postAuthorizationStep3,
      },
      {
        key: 3,
        describe: i18n.t('module_creative_post_tutorial_step_four'),
        url: postAuthorizationStep4,
      },
    ]);

    const describeText = ref(imgList.value[0]?.describe);

    function onStepChange(val) {
      describeText.value = imgList.value[val]?.describe || '';
      currentStep.value = val + 1;
    }

    /** 手动切换教程步骤
     * isNext: true 下一步 / false 上一步
     */
    function onChangeActiveItem(isNext) {
      if (isNext) {
        currentStep.value++;
      } else {
        currentStep.value--;
      }

      if (carouselTutorial.value) {
        carouselTutorial.value.setActiveItem(currentStep.value - 1);
      }
    }

    return {
      imgList,
      MIN_STEP,
      totalStep,
      currentStep,
      describeText,
      carouselTutorial,

      onStepChange,
      onChangeActiveItem,
      name,
    };
  },
});
</script>

<style lang="scss">
.tutorial {
  padding: 16px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .title {
    flex: 1;
    font-weight: $font-weight-bold;
    word-wrap: break-word;
  }
}

.stepDesc {
  padding-top: 8px;
  @include line-text();
}

.tutorialImg {
  padding-top: 8px;
}

.image {
  display: flex;
  margin: auto;
  width: 218px;
  height: 387px;
}

.operation {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 8px auto 0;
  .stepNum {
    padding: 0 12px;
  }
}
</style>
<style lang="scss">
$name: 'ttam-identity-tiktok-post-authorization-preview';
.#{$name} {
  padding: 16px;
  &-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      flex: 1;
      font-weight: $font-weight-bold;
      word-wrap: break-word;
    }
  }
  &-stepDesc {
    padding-top: 8px;
    @include line-text();
  }

  &-tutorialImg {
    padding-top: 8px;
  }

  &-image {
    display: flex;
    margin: auto;
    width: 218px;
    height: 387px;
  }

  &-operation {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 8px auto 0;
    .stepNum {
      padding: 0 12px;
    }
  }
}
</style>
